import { App } from "../models/app.model";

export namespace AppActions {
    export class Set {
        static readonly type = '[API-App] Set'
        constructor(public payload: App) {}
    }
}
